/* global axios */

const knowledgeProxy = (accountId, path) =>
  `/api/v1/accounts/${accountId}/proxy/knowledge${path}`;

const state = {
  condoAccessIds: null,
}

const mutations = {
  SET_CONDO_ACCESS_IDS(state, accounts) {
    state.condoAccessIds = accounts;
  },
}

const actions = {
  async fetchCondoAccess({ commit, rootGetters }) {
    const accountId = rootGetters.getCurrentAccountId;
    try {
      const { data } = await axios.get(
        knowledgeProxy(accountId, '/condo/access')
      );
      commit('SET_CONDO_ACCESS_IDS', data.accounts);
      return data;
    } catch (err) {
      throw err;
    }
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
